import { render, staticRenderFns } from "./OrdersDetailsModal.vue?vue&type=template&id=43d17b54&scoped=true&"
import script from "./OrdersDetailsModal.vue?vue&type=script&lang=js&"
export * from "./OrdersDetailsModal.vue?vue&type=script&lang=js&"
import style0 from "./OrdersDetailsModal.vue?vue&type=style&index=0&id=43d17b54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43d17b54",
  null
  
)

component.options.__file = "OrdersDetailsModal.vue"
export default component.exports